import { render, staticRenderFns } from "./JinNangList.vue?vue&type=template&id=620a9c8e&scoped=true"
import script from "./JinNangList.vue?vue&type=script&lang=js"
export * from "./JinNangList.vue?vue&type=script&lang=js"
import style0 from "./JinNangList.vue?vue&type=style&index=0&id=620a9c8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620a9c8e",
  null
  
)

export default component.exports